import { useConfigContext } from '../contexts/ConfigContext/ConfigContext';
import { getPathIdFromUrl } from '../utils/getPathIdFromUrl';

export function useGetCurrentPathId() {
  const currentPath = location.pathname;
  const {
    state: { currentLayout },
  } = useConfigContext();

  return getPathIdFromUrl(currentPath, currentLayout);
}
